module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_5.b29d2a57.png";